<template>
    <div class="collection">
        <nav-bar />
        <search-bar />
        <div class="nav black bold fr ac">我的收藏</div>
        <div class="main">
            <el-tabs v-model="tab">
                <el-tab-pane label="商品收藏" name="1"></el-tab-pane>
                <el-tab-pane label="文章收藏" name="2"></el-tab-pane>
            </el-tabs>
            <div class="fr fw" v-if="tab == '1'">
                <goods-cell
                    v-for="(i,j) in goods_list"
                    :key="i.goods_id"
                    :goods="i"
                    type="collection"
                    :class="{mr10:(j+1)%4 !=0}"
                    @insertCollection="insertCollection"
                />
            </div>
            <div class="fr fw" v-if="tab == '2'">
                <collection-cell
                    v-for="(i,j) in goods_list"
                    :key="i.information_id"
                    :info="i"
                    :loading="loading"
                    @insertCollection="insertCollection"
                />
            </div>
            <div class="fr jc ac">
                <el-pagination
                    :hide-on-single-page="true"
                    :current-page.sync="page"
                    layout="prev, pager, next"
                    :total="total"
                    class="mt30 mb30"
                ></el-pagination>
            </div>
        </div>
        <footer-bar />
    </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
import GoodsCell from "@/components/GoodsCell";
import CollectionCell from "./CollectionCell";

export default {
    props: {},
    data() {
        return {
            tab: "1",
            goods_list: [],
            page: 1,
            total: 0,
            loading: false
        };
    },
    computed: {},
    created() {
        this.getCollections();
    },
    watch: {
        tab(n) {
            this.getCollections();
        },
        page(n) {
            this.getCollections();
        }
    },
    methods: {
        insertCollection(obj) {
            this.$confirm("此操作将删除该收藏, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.post(
                        "collectionInterfaces/v1.0/insertCollection",
                        obj
                    ).then(res => {
                        this.$message({
                            type: "success",
                            message: "已取消收藏"
                        });
                        this.getCollections();
                    });
                })
                .catch(() => {});
        },
        getCollections() {
            this.loading = false;
            this.post("collectionInterfaces/v1.0/getCollections", {
                collection_type: this.tab,
                page: this.page
            }).then(res => {
                let arr = res.data;
                if (this.tab == "2") {
                    arr.forEach(el => {
                        el.information_img = el.information_imgs.split(",")[0];
                    });
                }
                this.goods_list = arr;
                this.total = res.total;
                this.loading = true;
            });
        }
    },
    components: {
        NavBar,
        SearchBar,
        FooterBar,
        "goods-cell": GoodsCell,
        CollectionCell
    }
};
</script>

<style scoped lang="scss">
.collection {
    font-size: 14px;
    .nav {
        width: 1200px;
        height: 50px;
        background: rgba(255, 255, 255, 1);
        margin: 20px auto;
        padding-left: 20px;
        padding-right: 20px;
    }
    .main {
        width: 1200px;
        margin: 0 auto;
        background-color: #fff;
        padding: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/me/Collection/index.vue